module.exports = __webpack_public_path__ + "img/Primordial-4.2f42fe9e.png";